import React from "react";
import Link from "gatsby-link";
import moment from "moment";

import glamorous from "glamorous";
import MantaCircleLogo from "../../assets/manta-circle-logo.png";

const createLinkStyle = ({ theme, glam = { linkStyle: "link" } }) => ({
  alignSelf: "center",
  border: glam.linkStyle === "button"
    ? `2px solid ${theme.main.colors.oceanLight}`
    : "none",
  borderRadius: "5px",
  fontFamily: theme.main.fontFamily,
  background: "none",
  display: "flex",
  textDecoration: "none",
  textShadow: "none",
  [":hover,:visited:hover"] : {
    background: glam.linkStyle === "button"
      ? theme.main.colors.oceanLight
      : "none",
    color: theme.main.colors.oceanLighter
  }
});
const NavLink = glamorous(Link)(createLinkStyle);
const ExternalLink = glamorous.a(createLinkStyle);

const FooterInnerDiv = glamorous.div(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  margin: "0 auto",
  maxWidth: theme.main.maxWidths.default,
  [theme.main.mediaQueries.mobile]: {
    flexDirection: "column",
    alignItems: "center",
    "&> *:not(:last-child)": {
      marginBottom: "1.5rem"
    }
  }
}));

const CopyrightNotice = glamorous.small(({ theme }) => ({
  [theme.main.mediaQueries.mobile]: {
    display: "none"
  }
}));

const FooterStack = ({ title, links }) => (
  <glamorous.Div padding="0 1rem">
     <glamorous.H4 marginBottom="0.5rem">{title}</glamorous.H4>
     {
      links.map(link => {
        if (link.disabled) {
          return (
            <glamorous.Span
              key={link.title}
              textDecoration="underlined"
              opacity="0.2"
            >
              {link.title}
            </glamorous.Span>
          );
        }

        return (link.external
          ? <ExternalLink target="blank" key={link.title} href={link.to}>{link.title}</ExternalLink>
          : <NavLink key={link.title} to={link.to}>{link.title}</NavLink>
        );
      })
     }
  </glamorous.Div>
);

const Footer = () => (
  <glamorous.Div padding="2.75rem 0">
    <FooterInnerDiv>
      <glamorous.Div display="flex" alignItems="center">
        <glamorous.Img
          src={MantaCircleLogo}
          maxWidth={75}
          marginBottom={0}
          marginRight="0.5rem"
        />
        <div>
          <glamorous.H4 marginBottom="0.25rem">Manta Equipment</glamorous.H4>
          <CopyrightNotice>&copy;{`EXN SIA ${moment().format("YYYY")}`}</CopyrightNotice>
        </div>
      </glamorous.Div>
      <glamorous.Div style={{ display: "flex" }}>
        <FooterStack
          title="Manta"
          links={[
            {
              to: "/",
              title: "Home"
            },
            {
              to: "/app",
              title: "Sign In"
            },
            {
              to: "/features",
              title: "Features"
            },
            {
              to: "/plans",
              title: "Plans"
            }
          ]}
        />
        <FooterStack
          title="Help"
          links={[
            {
              to: "/privacy",
              title: "Privacy"
            },
            {
              to: "/terms",
              title: "Terms"
            },
            {
              to: "/faq/accessibility",
              title: "Accessibility",
            }
          ]}
        />
        <FooterStack
          title="Social"
          links={[
            // {
            //   to: "https://www.twitter.com/MantaEquipment",
            //   title: "Twitter",
            //   external: true
            // },
            {
              to: "https://www.facebook.com/MantaEquipment",
              title: "Facebook",
              external: true
            },
            {
              to: "https://www.linkedin.com/company/manta-equipment",
              title: "LinkedIn",
              external: true
            }
          ]}
        />
      </glamorous.Div>
    </FooterInnerDiv>
  </glamorous.Div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js